<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
  -->

<template>
	<div>
		<div>
			<div class="mb-3"><strong>Invoice details:</strong></div>
			<div>{{invoice.title}}</div>
			<div class="small text-muted mb-3">#{{invoice.shortId}}</div>
			<div v-if="invoice.paidDateTs > 0">paid on {{invoice.paidDateFormatted()}}</div>
			<div v-if="invoice.sentDateTs > 0">sent on {{invoice.invoiceSentDateFormatted()}}</div>
		</div>
		<div v-if="invoice" class="my-4">
			<div>items:</div>
			<div v-for="(billingItem, index) in invoice.billingData.billingItems" :key="index">
				<b>{{currencyFormatted(billingItem.amount)}}</b> - {{billingItem.name}}
				{{billingItem.additionalNote}}
			</div>
			<br/>
			<strong>{{currencyFormatted(invoice.billingData.totalAmount())}} - total</strong>
		</div>
	</div>

</template>

<script>
    import InvoiceItem from "@/core/js/model/Invoice/InvoiceItem";

	import BaseComponent from "@/core/components/BaseComponent.vue";

	export default {
		extends: BaseComponent,
        name: "InvoiceDetails",
		props:{
        	invoice: InvoiceItem
		}
    }
</script>

<style>

</style>
